import { CustomerSettingService } from "./../shared/service/customer-setting.service";
import { Component, OnInit } from "@angular/core";
declare var jquery: any;
declare var $: any;

@Component({
  selector: "app-dashboard",
  templateUrl: "./dashboard.component.html",
  styleUrls: ["./dashboard.component.css"],
})
export class DashboardComponent implements OnInit {
  settings?: Array<any> = [];
  constructor(private customerSettingService: CustomerSettingService) {}

  ngOnInit() {
    let localSetting = localStorage.getItem("settings-dashboard");
    if (localSetting == null) {
      this.getCustomerSettings();
    }
    else
    {
       this.settings = JSON.parse(localSetting);
    }
  }

  getCustomerSettings() {
    this.customerSettingService.get().subscribe((res) => {
      this.settings = res.data;
      localStorage.setItem("settings-dashboard", JSON.stringify(this.settings));
      console.log(this.settings);
    });
  }
}
